import { create as createStore } from 'zustand';

type BulkSelectionState = {
  selectedIds: string[];
  isBulkEditBarOpen: boolean;
  setSelectedIds: (ids: string[]) => void;
  clear: () => void;
  openBulkEditBar: () => void;
  closeBulkEditBar: () => void;
};

export const useBulkSelection = createStore<BulkSelectionState>(set => ({
  selectedIds: [],
  isBulkEditBarOpen: false,
  setSelectedIds: (ids: string[]) => set({ selectedIds: ids }),
  clear: () => set({ selectedIds: [], isBulkEditBarOpen: false }),
  openBulkEditBar: () => set({ isBulkEditBarOpen: true }),
  closeBulkEditBar: () => set({ isBulkEditBarOpen: false })
}));
